import { PROMOTION_SERVICES, STANDARD_SERVICES } from '../../../../../constants/services';
import { EServices, IBetsPositionService } from '../../../../../repositories/auction/v1/get-bets-position';
import { EServiceId } from '../../../../reducers';

interface IGetBetPositionServicesParams {
  serviceIds: EServiceId[];
  packageIds: EServiceId[];
  currentBet: number;
  isAuctionEnabled: boolean;
  isPromotionPackageSelected: boolean;
}

const SERVICE_MAP: { [serviceId in EServiceId]: EServices } = {
  [EServiceId.top]: EServices.Top3,
  [EServiceId.premium]: EServices.Premium,
  [EServiceId.paid]: EServices.Paid,
  [EServiceId.free]: EServices.Free,
};

export function getBetPositionServices(params: IGetBetPositionServicesParams): IBetsPositionService[] {
  const { serviceIds, packageIds, currentBet, isAuctionEnabled, isPromotionPackageSelected } = params;

  // Для пакета на топ/премиум карточки услуг не отображаются.
  // Позиции загружаем только для пакетов на топ/премиум.
  // При включении пакета на платное, позиции будут перезапрашиваться
  if (isPromotionPackageSelected) {
    return packageIds
      .filter(packageId => PROMOTION_SERVICES.includes(packageId))
      .map(serviceId => {
        const bet = isAuctionEnabled ? currentBet : 0;

        return {
          serviceId: SERVICE_MAP[serviceId],
          bet,
        };
      });
  }

  return serviceIds.map(serviceId => {
    const bet = STANDARD_SERVICES.includes(serviceId) && isAuctionEnabled ? currentBet : 0;

    return {
      serviceId: SERVICE_MAP[serviceId],
      bet,
    };
  });
}
